"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const SvgAttachment = (props) => (React.createElement("span", { className: "anticon" },
    React.createElement("svg", Object.assign({ fill: "none", stroke: "currentColor", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", className: "PayPing-icon" }, props),
        React.createElement("g", { transform: "matrix(1.0069 -1.0069 1.0069 1.0069 -11.662 12.504)", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5px" },
            React.createElement("path", { d: "m10 11a4 4 0 0 1 4-4h2.5a4.5 4.5 0 0 1 4.5 4.5 4.5 4.5 0 0 1-4.5 4.5h-0.5" }),
            React.createElement("path", { d: "m14 12a4 4 0 0 1-4 4h-2.5a4.5 4.5 0 0 1-4.5-4.5 4.5 4.5 0 0 1 4.5-4.5h0.5" })))));
exports.default = SvgAttachment;
//# sourceMappingURL=Attachment.js.map